import { render, staticRenderFns } from "./ViewCrosses.vue?vue&type=template&id=0515ddbf"
import script from "./ViewCrosses.ts?vue&type=script&lang=ts&external"
export * from "./ViewCrosses.ts?vue&type=script&lang=ts&external"
import style0 from "./ViewCrosses.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports